/**
 * Process aliases initial values
 * @param {Array<String>} initialValues
 * @param {String} defaultValue
 * @param {String} customValue
 * @param {String} customOptions
 * @param {Array<String>} globalInitials
 * @returns {Array<String>}
 */
const processInitialValues = (
  initialValues,
  defaultValue,
  customValue,
  customOptions,
  globalInitials
) => {
  const result = globalInitials || [];

  if (customValue) {
    /** Check if "initial" value accepts a custom value */
    for (const initial of initialValues) {
      let replaced = initial.replace(/«V»/g, customValue);

      if (initial.includes("«O»")) {
        replaced = replaced.replace(/«O»/g, customOptions);
      }

      result.push(replaced);
    }
  } else {
    /** Check if "initial" value accepts a custom value */
    for (const initial of initialValues) {
      let replaced = initial.replace(/«V»/g, defaultValue);

      if (initial.includes("«O»")) {
        replaced = replaced.replace(/«O»/g, customOptions);
      }

      result.push(replaced);
    }
  }

  return result;
};

export default processInitialValues;
